import React, { useState, useEffect } from "react";
import { Table, Space, Row, Col, Input, Select, Button, Modal, notification, Tooltip, Pagination, Tag, Badge } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { dropdownService, vehicleService } from "../../../services";
import { checkPermission } from '../../../utils/permissions';
import { useDebounce } from "../../../hooks/useDebounce";
import { changeDocumentTitle } from "../../../utils/title";
import { withDefaultRender } from "../../../utils/tableDefaultRender";
import { LuTruck } from "react-icons/lu";


function RecentVehicle() {
    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [vehicles, setVehicles] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [search, setSearch] = useState(null)
    const [status, setStatus] = useState([])
    const [pagination, setPagination] = useState({
        current: 1,
        total: 0,
        pageSize: 10,
    });

    const debouncedSearch = useDebounce(search, 500);

    const [customer, setCustomer] = useState([])
    const startYear = 1990;
    const endYear = new Date().getFullYear();

    const yearOptions = [];
    for (let y = endYear; y >= startYear; y--) {
        yearOptions.push({ label: String(y), value: String(y) });
    }

    const columns = withDefaultRender([
        {
            title: "Id",
            dataIndex: "id",
            key: "id",
        },
        {
            title: "Car Status",
            dataIndex: "car_status",
            key: "car_status",
            render: (text) => (
                <>
                    {text === "LOADED" ? <Tag color="green">{text}</Tag> : text === "AT YARD" ? <Tag color="gold">{text}</Tag> : text === "IN LOAD PLAN" ? <Tag color="blue">{text}</Tag> : text === "RETURNED" ? <Tag color="red">{text}</Tag> : null}
                </>
            )
        },
        {
            title: "Product",
            dataIndex: "product",
            key: "product",
            render: (value) => value ? value : "-",
        },
        {
            title: "Vehicle",
            dataIndex: "vehicle",
            key: "vehicle",
            render: (value) => value ? value : "-",
        },

        {
            title: "VIN Number",
            dataIndex: "chasis_no",
            key: "chasis_no",
        },
        {
            title: "Customer",
            dataIndex: "customer_name",
            key: "customer_name",
            render: (text, record) => {
                if (!text) return "";

                const formattedName = text
                    .split(" ")
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ");

                return (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                        <span>{formattedName}</span>

                        {record?.is_globex_vehicle === 1 && (
                            <Tag color="#3dabce" style={{ fontSize: 8 }}>
                                GLOBEX
                            </Tag>
                        )}
                    </div>
                );
            },
        },
        {
            title: "Action",
            key: "Action",
            fixed: "right",
            render: (text, record, { _id }) => (
                <Link to={`/vehicle/${record.id}`} className="hover:text-primary">
                    <Tooltip title="View">
                        {/* <Button type="primary" size="small"> */}
                        <EyeOutlined />
                        {/* </Button> */}
                    </Tooltip>
                </Link>
            ),
        },
    ])

    const showModal = (record) => {
        setSelectedRecord(record);
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setSelectedRecord(null);
    };

    const handleOk = async () => {
        if (!selectedRecord) return;
        setDeleteLoading(true);
        const response = await vehicleService.deleteVehicle(selectedRecord.id);
        if (response?.success) {
            notification.success({
                message: "Deleted Successfully",
                description: response.message,
                placement: "topRight",
            });
            setIsModalVisible(false);
            initialize();
        }
        setDeleteLoading(false);
        setSelectedRecord(null);
    };

    const initialize = async (page = 1, pageSize = pagination.pageSize) => {
        try {
            setLoading(true);
            const { success, data, message } = await vehicleService.getVehicles(page, debouncedSearch);

            if (success) {
                if (data && data.vehicles && data.vehicles.data.length > 0) {
                    setVehicles(data?.vehicles?.data);
                    setStatus(data.status_counts)
                    setPagination((prev) => ({
                        ...prev,
                        total: data.vehicles.total,
                        current: page,
                        pageSize,
                    }));
                } else {
                    console.warn("No vehicles data found.");
                    setVehicles([]); // Clear vehicle list if no data is present
                }
            } else {
                console.error(`Error: ${message || "Failed to fetch vehicles."}`);
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
        } finally {
            setLoading(false);
        }
    };


    const deleteModal = (
        <>
            <Modal
                title={<div style={{ textAlign: "center" }}>Confirm</div>}
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                centered
                style={{
                    padding: "20px",
                }}
                width={300}
                footer={
                    <div className="flex justify-center gap-3">
                        <Button
                            type="default"
                            onClick={handleCancel}
                            style={{ width: "30%" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            onClick={handleOk}
                            loading={deleteLoading}
                        >
                            Confirm
                        </Button>
                    </div>
                }
            >
                <p style={{ textAlign: "center" }}>
                    Are you sure you want to delete this?
                </p>
            </Modal>
        </>
    )
    const allCustomer = async () => {
        const response = await dropdownService.fetchCustomers()
        if (response?.success) {
            setCustomer(response.data)
        }
    }

    useEffect(() => {
        changeDocumentTitle("Vehicles");
        allCustomer();
    }, []);

    // Run ONLY when filters/search change
    useEffect(() => {
        initialize(pagination.current, pagination.pageSize);
    }, [debouncedSearch]);
    return (
        <>
            <div style={{ padding: "20px", border: "1px solid #ccc", borderRadius: "8px", backgroundColor: "#FFFFFF" }}>

                <div className='flex gap-2 items-center'>
                    <span className='bg-[#F0FDF4] rounded-md p-2'>
                        <LuTruck className='!text-base' style={{ color: '#00A63E' }} />
                    </span>
                    <h1 style={{ fontWeight: "bold", padding: 0, margin: 0 }}>Recently Added Vehicles</h1>
                </div>

                <Table
                    columns={columns}
                    dataSource={vehicles}
                    loading={loading}
                    rowKey="id"
                    scroll={{ x: "max-content" }}
                    pagination={false}
                    style={{ marginTop: "10px" }}
                    footer={() => (
                        <div className="flex justify-between items-center text-xs ">
                            <div className=" text-gray-600">
                                Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                                {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                                {pagination.total} entries
                            </div>
                            <Pagination
                                current={pagination.current}
                                total={pagination.total}
                                pageSize={pagination.pageSize}
                                showSizeChanger={false}
                                onChange={(page) => initialize(page, pagination.pageSize, search)}
                                itemRender={(current, type, originalElement) => {
                                    if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                                    if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                                    return originalElement;
                                }}
                            />
                        </div>
                    )}
                />

                {/* Delete Modal */}
                {deleteModal}
            </div>
        </>
    );
}

export default RecentVehicle;
